// TODO: customize overwrite theme
import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const Container = styled.div`
  line-height: 1.5;
  font-family: "Open Sans", Helvetica, Arial, sans-serif, "微軟正黑體";
  color: #666;
  ${props =>
    props.zh &&
    css`
      font-family: "Noto Sans TC", sans-serif;
      font-weight: 300;
    `};
`;

export const DEFAULT_THEME = {
  color: {
    mainVisual: "#0abab5",
    font: {
      main: "#666",
      second: "#999",
      third: "#ccc",
      mainVisual: "#089b96",
      mainVisualDark: "#078A86"
    },
    risk: {
      low: "#85ca2a",
      mediumlow: "#fdbf60",
      medium: "#fd854c",
      mediumhigh: "#e65c39",
      high: "#c73424",
      mediumlowDisable: "#ffeccc",
      mediumDisable: "#ffdac7",
      mediumhighDisable: "#f8cdc0",
      highDisable: "#efc1ba"
    },
    return: {
      up: "#27ac66",
      down: "#da563e"
    },
    sector: {
      red: "#e35046",
      orange: "#fd8d3c",
      yellow: "#ffc800",
      green: "#31a354",
      blue: "#3182bd",
      purple: "#756bb1"
    },
    chart: {
      line: [
        "#31a5cc",
        "#2da29e",
        "#0ABAD7",
        "#4BB3B1",
        "#fd8d3c",
        "#3182bd",
        "#e35046",
        "#ffc800",
        "#756bb1"
      ]
    }
  },
  layoutSpace: {
    xxl: "60px",
    xl: "45px",
    l: "30px",
    ml: "20px",
    m: "15px",
    s: "10px",
    xs: "8px",
    xxs: "5px",
    xxxs: "3px"
  },
  fontSize: {
    xxxl: "28px",
    xxl: "24px",
    xl: "20px",
    l: "18px",
    m: "16px",
    s: "14px",
    xs: "12px",
    xxs: "10px"
  },
  deviceSize: {
    laptop: 1440,
    tabletL: 1199,
    tablet: 991,
    tabletS: 768,
    mobileL: 425,
    mobileS: 320
  }
};

export default class ThemeProvider extends React.Component {
  getChildContext() {
    return {
      theme: this.props.theme || DEFAULT_THEME
    };
  }

  render() {
    return (
      <Container>
        <link
          href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
          rel="stylesheet"
        />
        {this.props.children}
      </Container>
    );
  }
}

ThemeProvider.childContextTypes = {
  theme: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/styles/ThemeProvider.js